import * as signalR from "@microsoft/signalr";

let connection = null;
let startPromise = null;

export async function startConnection(token) {
  if (!connection) {
    connection = new signalR.HubConnectionBuilder()
      .withUrl(
        window.location.hostname === "localhost"
          ? "http://localhost:5000/api/chathub"
          : "/api/chathub",
        {
          accessTokenFactory: () => token || "",
        }
      )
      .withAutomaticReconnect()
      .build();

    connection.onreconnected(() => {
      console.log("SignalR reconectado");
    });

    connection.onclose(() => {
      console.log("SignalR fechado");
    });
  }

  if (connection.state === signalR.HubConnectionState.Connected) {
    console.log("SignalR já estava ligado");
    return connection;
  }

  if (connection.state === signalR.HubConnectionState.Connecting) {
    console.log("SignalR ainda está a ligar — a aguardar");
    if (startPromise) {
      await startPromise;
    }
    return connection;
  }

  try {
    startPromise = connection.start();
    await startPromise;
    console.log("SignalR ligado com sucesso");
  } catch (err) {
    console.error("Erro SignalR ao ligar:", err);
  } finally {
    startPromise = null;
  }

  return connection;
}

export function getConnection() {
  return connection;
}
